// Translations for the website
const translations = {
  // English translations
  en: {
    // Navigation
    nav: {
      home: 'Home',
      bio: 'Bio',
      shows: 'Shows',
      video: 'Video',
      gallery: 'Gallery',
      social: 'Social',
      booking: 'Booking'
    },
    // Home page
    home: {
      hero: {
        title: 'AYITE',
        subtitle: 'Driven by the pulsating energy of Afro Tech, seamlessly blending it with the emotional depth and rich melodies of Afro House.'
      },
      bio: {
        title: 'Bio',
        paragraph1: 'AYITE is a DJ and producer driven by the pulsating energy of Afro Tech, seamlessly blending it with the emotional depth and rich melodies of Afro House. His sets are more than just music—they\'re immersive experiences rooted in connection, movement, and the raw energy shared with the crowd.',
        paragraph2: 'Drawing from the heavy basslines of Techno, AYITE infuses his Afro Tech sound with a powerful yet soulful edge. His productions weave in elements of Peak Time Techno and Electronica, blending dark, driving basslines with raw, distorted textures to create a sound that\'s both personal and boundary-pushing.',
        paragraph3: 'What truly sets AYITE apart is his intuitive understanding of dancefloor dynamics. His ability to read a crowd and guide them on a journey of shared euphoria turns each performance into an unforgettable moment.',
        readMore: 'Read Full Bio'
      },
      events: {
        title: 'AYITE Live Shows',
        subtitle: 'Connecting people and hearts through music. Deep basslines and emotional melodies flow through every beat - Afro Tech leads the way. Let the rhythm move you, let the energy carry you. This is more than a sound - it\'s a feeling! ♥️',
        viewAll: 'View All Events'
      },
      music: {
        title: 'Listen to My Music',
        followText: 'Follow me on',
        platform: 'SoundCloud',
        forMoreTracks: 'for more tracks'
      },
      gallery: {
        title: 'Gallery',
        viewAll: 'View Full Gallery'
      },
      booking: {
        title: 'Booking',
        text: 'Interested in booking AYITE for your event? Contact directly on Instagram.',
        button: 'More Booking Info'
      }
    },
    // SoundCloud player
    soundcloud: {
      tracks: 'Tracks',
      playlists: 'Playlists',
      reposts: 'Reposts'
    },
    // Social page
    social: {
      title: 'Social Media',
      allPlatforms: 'All Platforms',
      followInstagram: 'Follow on Instagram',
      followTikTok: 'Follow on TikTok',
      subscribeYouTube: 'Subscribe on YouTube',
      followSpotify: 'Follow on Spotify',
      followSoundCloud: 'Follow on SoundCloud',
      youtubePlaylist: 'Featured Playlist',
      videos: 'Videos',
      shorts: 'Shorts',
      playlists: 'Playlists'
    },
    // Video page
    video: {
      featuredVideo: 'Featured Video',
      youtubeShorts: 'YouTube Shorts',
      youtubePlaylist: 'YouTube Playlist',
      subscribeButton: 'Subscribe to My YouTube Channel'
    },
    // Gallery page
    gallery: {
      title: 'Gallery',
      closeButton: 'Close',
      placeholder: 'Placeholder Image',
      allPhotos: 'All Photos',
      profilePhotos: 'Profile Photos',
      instagramPhotos: 'Instagram Photos'
    },
    // Booking page
    booking: {
      title: 'Booking',
      contactHeading: 'Contact for Bookings',
      contactText: 'For booking inquiries, please contact AYITE directly on Instagram:',
      alternativeHeading: 'Alternative Contact',
      alternativeText: 'You can also reach out via email:',
      pressKitHeading: 'Press Kit & Booking Information',
      pressKitText: 'View complete press kit, photos, technical rider, and booking details:',
      viewPressKit: 'Watch the Press Kit',
      requestInfo: 'Please include the following information in your booking request:',
      eventDate: 'Event date and time',
      venueLocation: 'Venue name and location',
      eventType: 'Event type and expected audience',
      setDuration: 'Set duration and any specific requirements'
    },
    // Bio page
    bio: {
      title: 'Biography',
      paragraph1: 'AYITE is a DJ and producer driven by the pulsating energy of Afro Tech, seamlessly blending it with the emotional depth and rich melodies of Afro House. His sets are more than just music—they\'re immersive experiences rooted in connection, movement, and the raw energy shared with the crowd.',
      paragraph2: 'Drawing from the heavy basslines of Techno, AYITE infuses his Afro Tech sound with a powerful yet soulful edge. On a mission to carve out his own sonic identity, AYITE stays grounded in Afro Tech while fearlessly exploring new sonic territories.',
      paragraph3: 'His productions weave in elements of Peak Time Techno and Electronica, blending dark, driving basslines with raw, distorted textures to create a sound that\'s both personal and boundary-pushing. It\'s a fusion of power and emotion, rhythm and innovation.',
      paragraph4: 'In the studio, AYITE is equally forward-thinking—pushing the boundaries of electronic music with every release. His productions combine sophisticated sound design with emotional resonance, earning growing support from fans who crave substance in dance music.',
      paragraph5: 'But what truly sets AYITE apart is his intuitive understanding of dancefloor dynamics. His ability to read a crowd and guide them on a journey of shared euphoria turns each performance into an unforgettable moment.',
      paragraph6: 'As electronic music continues to evolve, AYITE remains committed to the underground ethos and the African spirit, constantly refining his craft with authenticity and purpose.',
      paragraph7: 'Whether behind the decks or in the studio, he delivers music that resonates far beyond the club walls—anchored in rhythm, storytelling, and soul.'
    },
    // Shows page
    shows: {
      title: 'Shows',
      subtitle: 'AYITE',
      tagline: 'Connecting people and hearts through music. Deep basslines and emotional melodies flow through every beat - Afro Tech leads the way. Let the rhythm move you, let the energy carry you. This is more than a sound - it\'s a feeling! ♥️',
      loading: 'Loading events...',
      upcomingEvents: 'Upcoming Events',
      pastEvents: 'Past Events',
      noUpcoming: 'No upcoming events at the moment. Check back soon!',
      noPast: 'No past events to display.',
      getTickets: 'Get Tickets',
      bookingInfo: 'Booking Information',
      bookingContact: 'For bookings and inquiries:',
      followXceed: 'Follow on Xceed',
      contactBooking: 'Contact for Booking',
      errorMessage: 'Unable to fetch live events. Using sample event data.',
      showMorePast: 'Show More Past Events'
    },
    // Footer
    footer: {
      copyright: '© 2025 AYITE. All rights reserved.',
      followMe: 'Follow me on social media',
      createdBy: 'Created with',
      pressKit: 'Press Kit',
      impressum: 'Impressum',
      privacy: 'Privacy Policy'
    },
    // Legal pages
    legal: {
      impressum: 'Impressum',
      responsible: 'Responsible for Content',
      vatId: 'VAT ID',
      disclaimer: 'Disclaimer',
      liability: {
        content: 'Liability for Content',
        contentText: 'The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents\' accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this matter, please note that we are not obliged to monitor the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.',
        links: 'Liability for Links',
        linksText: 'Our offer includes links to external third-party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for their own contents.',
        copyright: 'Copyright',
        copyrightText: 'The contents and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution, or any form of commercialization of such material beyond the scope of the copyright law shall require the prior written consent of its respective author or creator.'
      },
      privacy: 'Privacy Policy',
      dataProtection: 'Data Protection',
      dataProtectionIntro: 'The operators of this website take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the statutory data protection regulations and this privacy policy.',
      dataCollection: 'Data Collection',
      dataCollectionText: 'The use of our website is generally possible without providing personal data. Personal data, such as names, addresses or email addresses, are always provided on a voluntary basis when possible.',
      logData: 'Server Log Files',
      logDataText: 'The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are: browser type and browser version, operating system used, referrer URL, host name of the accessing computer, time of the server request. This data cannot be assigned to specific persons. This data is not merged with other data sources.',
      cookies: 'Cookies',
      cookiesText: 'Our website uses cookies. Cookies are text files that are stored in the internet browser or by the internet browser on the user\'s computer system. Cookies do not cause any damage to your computer and do not contain viruses.',
      thirdParty: 'Third-Party Services',
      thirdPartyText: 'This website uses services from third-party providers. These services may collect data about your usage behavior.',
      soundcloudText: 'Our site uses widgets from SoundCloud. The provider is SoundCloud Limited, Rheinsberger Str. 76/77, 10115 Berlin, Germany. When you visit our pages with the SoundCloud plugin, a connection to SoundCloud\'s servers is established.',
      youtubeText: 'Our website uses plugins from YouTube, which is operated by Google. The operator of the pages is YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. If you visit one of our pages featuring a YouTube plugin, a connection to the YouTube servers is established.',
      instagramText: 'Our website uses functions of the Instagram service. These functions are offered by Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, USA. If you are logged into your Instagram account, you can link the content of our pages to your Instagram profile by clicking on the Instagram button.',
      tiktokText: 'Our website uses functions of TikTok. These functions are offered by TikTok Inc., 10100 Venice Blvd, Culver City, CA 90232, USA. When you visit our pages with TikTok content, a connection to TikTok\'s servers is established.',
      rights: 'Your Rights',
      rightsText: 'You have the right to receive information about your stored personal data, its origin and recipient and the purpose of data processing at any time, free of charge. You also have a right to correction, blocking or deletion of this data. You can contact us at any time at the address given in the impressum for further questions on the subject of personal data.',
      contact: 'Contact',
      contactText: 'If you have any questions regarding data protection, please send us an email or contact the person responsible for data protection in our organization:'
    }
  },

  // German translations
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      bio: 'Biografie',
      shows: 'Auftritte',
      video: 'Video',
      gallery: 'Galerie',
      social: 'Social Media',
      booking: 'Buchung'
    },
    // Home page
    home: {
      hero: {
        title: 'AYITE',
        subtitle: 'Angetrieben von der pulsierenden Energie des Afro Tech, nahtlos verbunden mit der emotionalen Tiefe und den reichen Melodien des Afro House.'
      },
      bio: {
        title: 'Biografie',
        paragraph1: 'AYITE ist ein DJ und Producer, der von der pulsierenden Energie des Afro Tech angetrieben wird und diese nahtlos mit der emotionalen Tiefe und den reichen Melodien des Afro House verbindet. Seine Sets sind mehr als nur Musik – sie sind immersive Erlebnisse, die in Verbindung, Bewegung und der rohen Energie verwurzelt sind, die er mit dem Publikum teilt.',
        paragraph2: 'Inspiriert von den schweren Basslines des Techno, verleiht AYITE seinem Afro Tech Sound eine kraftvolle, aber soulvolle Note. Seine Produktionen verweben Elemente von Peak Time Techno und Electronica und verbinden dunkle, treibende Basslines mit rauen, verzerrten Texturen zu einem Sound, der sowohl persönlich als auch grenzenüberschreitend ist.',
        paragraph3: 'Was AYITE wirklich auszeichnet, ist sein intuitives Verständnis der Dancefloor-Dynamik. Seine Fähigkeit, das Publikum zu lesen und es auf eine Reise gemeinsamer Euphorie zu führen, macht jede Performance zu einem unvergesslichen Moment.',
        readMore: 'Vollständige Biografie lesen'
      },
      events: {
        title: 'AYITE Live Shows',
        subtitle: 'Menschen und Herzen durch Musik verbinden. Tiefe Basslines und emotionale Melodien fließen durch jeden Beat - Afro Tech führt den Weg. Lass dich vom Rhythmus bewegen, lass die Energie dich tragen. Das ist mehr als Sound - es ist ein Gefühl! ♥️',
        viewAll: 'Alle Veranstaltungen anzeigen'
      },
      music: {
        title: 'Mein Sound',
        followText: 'Folge mir auf',
        platform: 'SoundCloud',
        forMoreTracks: 'für mehr Tracks'
      },
      gallery: {
        title: 'Galerie',
        viewAll: 'Vollständige Galerie anzeigen'
      },
      booking: {
        title: 'Buchung',
        text: 'Interesse an einer Buchung von AYITE für deine Veranstaltung? Kontaktiere mich direkt über Instagram.',
        button: 'Weitere Buchungsinfos'
      }
    },
    // SoundCloud player
    soundcloud: {
      tracks: 'Tracks',
      playlists: 'Playlists',
      reposts: 'Reposts'
    },
    // Social page
    social: {
      title: 'Social Media',
      allPlatforms: 'Alle Plattformen',
      followInstagram: 'Auf Instagram folgen',
      followTikTok: 'Auf TikTok folgen',
      subscribeYouTube: 'YouTube abonnieren',
      followSpotify: 'Auf Spotify folgen',
      followSoundCloud: 'Auf SoundCloud folgen',
      youtubePlaylist: 'Ausgewählte Playlist',
      videos: 'Videos',
      shorts: 'Shorts',
      playlists: 'Playlists'
    },
    // Video page
    video: {
      featuredVideo: 'Ausgewähltes Video',
      youtubeShorts: 'YouTube Shorts',
      youtubePlaylist: 'YouTube Playlist',
      subscribeButton: 'Meinen YouTube-Kanal abonnieren'
    },
    // Gallery page
    gallery: {
      title: 'Galerie',
      closeButton: 'Schließen',
      placeholder: 'Platzhalterbild',
      allPhotos: 'Alle Fotos',
      profilePhotos: 'Profilfotos',
      instagramPhotos: 'Instagram-Fotos'
    },
    // Booking page
    booking: {
      title: 'Buchung',
      contactHeading: 'Kontakt für Buchungen',
      contactText: 'Für Buchungsanfragen kontaktieren Sie AYITE direkt auf Instagram:',
      alternativeHeading: 'Alternative Kontaktmöglichkeit',
      alternativeText: 'Sie können auch per E-Mail Kontakt aufnehmen:',
      pressKitHeading: 'Pressekit & Buchungsinformationen',
      pressKitText: 'Vollständiges Pressekit, Fotos, Technical Rider und Buchungsdetails ansehen:',
      viewPressKit: 'Pressekit anschauen',
      requestInfo: 'Bitte geben Sie folgende Informationen in Ihrer Buchungsanfrage an:',
      eventDate: 'Veranstaltungsdatum und -zeit',
      venueLocation: 'Name und Ort der Location',
      eventType: 'Art der Veranstaltung und erwartetes Publikum',
      setDuration: 'Set-Dauer und spezifische Anforderungen'
    },
    // Bio page
    bio: {
      title: 'Biografie',
      paragraph1: 'AYITE ist ein DJ und Producer, der von der pulsierenden Energie des Afro Tech angetrieben wird und diese nahtlos mit der emotionalen Tiefe und den reichen Melodien des Afro House verbindet. Seine Sets sind mehr als nur Musik – sie sind immersive Erlebnisse, die in Verbindung, Bewegung und der rohen Energie verwurzelt sind, die er mit dem Publikum teilt.',
      paragraph2: 'Inspiriert von den schweren Basslines des Techno, verleiht AYITE seinem Afro Tech Sound eine kraftvolle, aber soulvolle Note. Auf der Mission, seine eigene klangliche Identität zu entwickeln, bleibt AYITE im Afro Tech verwurzelt, während er furchtlos neue klangliche Territorien erkundet.',
      paragraph3: 'Seine Produktionen verweben Elemente von Peak Time Techno und Electronica und verbinden dunkle, treibende Basslines mit rauen, verzerrten Texturen zu einem Sound, der sowohl persönlich als auch grenzenüberschreitend ist. Es ist eine Fusion aus Kraft und Emotion, Rhythmus und Innovation.',
      paragraph4: 'Im Studio ist AYITE ebenso zukunftsorientiert – er verschiebt mit jeder Veröffentlichung die Grenzen der elektronischen Musik. Seine Produktionen verbinden anspruchsvolles Sounddesign mit emotionaler Resonanz und erhalten wachsende Unterstützung von Fans, die Substanz in Tanzmusik suchen.',
      paragraph5: 'Was AYITE jedoch wirklich auszeichnet, ist sein intuitives Verständnis der Dancefloor-Dynamik. Seine Fähigkeit, das Publikum zu lesen und es auf eine Reise gemeinsamer Euphorie zu führen, macht jede Performance zu einem unvergesslichen Moment.',
      paragraph6: 'Während sich die elektronische Musik weiterentwickelt, bleibt AYITE dem Underground-Ethos und dem afrikanischen Geist verpflichtet und verfeinert ständig sein Handwerk mit Authentizität und Zielstrebigkeit.',
      paragraph7: 'Ob hinter den Decks oder im Studio – er liefert Musik, die weit über die Clubwände hinaus resoniert und in Rhythmus, Storytelling und Soul verankert ist.'
    },
    // Shows page
    shows: {
      title: 'Auftritte',
      subtitle: 'AYITE',
      tagline: 'Menschen und Herzen durch Musik verbinden. Tiefe Basslines und emotionale Melodien fließen durch jeden Beat - Afro Tech führt den Weg. Lass dich vom Rhythmus bewegen, lass die Energie dich tragen. Das ist mehr als Sound - es ist ein Gefühl! ♥️',
      loading: 'Veranstaltungen werden geladen...',
      upcomingEvents: 'Kommende Veranstaltungen',
      pastEvents: 'Vergangene Veranstaltungen',
      noUpcoming: 'Derzeit keine kommenden Veranstaltungen. Schau bald wieder vorbei!',
      noPast: 'Keine vergangenen Veranstaltungen anzuzeigen.',
      getTickets: 'Tickets kaufen',
      bookingInfo: 'Buchungsinformationen',
      bookingContact: 'Für Buchungen und Anfragen:',
      followXceed: 'Auf Xceed folgen',
      contactBooking: 'Kontakt für Buchung',
      errorMessage: 'Live-Events konnten nicht abgerufen werden. Es werden Beispieldaten verwendet.',
      showMorePast: 'Mehr vergangene Veranstaltungen anzeigen'
    },
    // Footer
    footer: {
      copyright: '© 2025 AYITE. Alle Rechte vorbehalten.',
      followMe: 'Folge mir auf Social Media',
      createdBy: 'Erstellt mit',
      pressKit: 'Pressekit',
      impressum: 'Impressum',
      privacy: 'Datenschutzerklärung'
    },
    // Legal pages
    legal: {
      impressum: 'Impressum',
      responsible: 'Verantwortlich für den Inhalt',
      vatId: 'Umsatzsteuer-ID',
      disclaimer: 'Haftungsausschluss',
      liability: {
        content: 'Haftung für Inhalte',
        contentText: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
        links: 'Haftung für Links',
        linksText: 'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
        copyright: 'Urheberrecht',
        copyrightText: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.'
      },
      privacy: 'Datenschutzerklärung',
      dataProtection: 'Datenschutz',
      dataProtectionIntro: 'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.',
      dataCollection: 'Datenerfassung',
      dataCollectionText: 'Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.',
      logData: 'Server-Log-Files',
      logDataText: 'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage. Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.',
      cookies: 'Cookies',
      cookiesText: 'Unsere Website verwendet Cookies. Cookies sind Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert werden. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.',
      thirdParty: 'Dienste Dritter',
      thirdPartyText: 'Diese Website nutzt Dienste von Drittanbietern. Diese Dienste können Daten über Ihr Nutzungsverhalten erheben.',
      soundcloudText: 'Unsere Seite nutzt Widgets von SoundCloud. Anbieter ist die SoundCloud Limited, Rheinsberger Str. 76/77, 10115 Berlin, Deutschland. Wenn Sie unsere Seiten mit dem SoundCloud-Plugin besuchen, wird eine Verbindung zu den Servern von SoundCloud hergestellt.',
      youtubeText: 'Unsere Website nutzt Plugins von YouTube, das von Google betrieben wird. Betreiber der Seiten ist die YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt.',
      instagramText: 'Unsere Website nutzt Funktionen des Dienstes Instagram. Diese Funktionen werden angeboten durch die Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, USA. Wenn Sie in Ihrem Instagram-Account eingeloggt sind, können Sie durch Anklicken des Instagram-Buttons die Inhalte unserer Seiten mit Ihrem Instagram-Profil verlinken.',
      tiktokText: 'Unsere Website nutzt Funktionen von TikTok. Diese Funktionen werden angeboten durch die TikTok Inc., 10100 Venice Blvd, Culver City, CA 90232, USA. Wenn Sie unsere Seiten mit TikTok-Inhalten besuchen, wird eine Verbindung zu den Servern von TikTok hergestellt.',
      rights: 'Ihre Rechte',
      rightsText: 'Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.',
      contact: 'Kontakt',
      contactText: 'Bei Fragen zum Datenschutz schicken Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:'
    }
  },

  // Spanish translations
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      bio: 'Biografía',
      shows: 'Eventos',
      video: 'Video',
      gallery: 'Galería',
      social: 'Redes Sociales',
      booking: 'Contratación'
    },
    // Home page
    home: {
      hero: {
        title: 'AYITE',
        subtitle: 'Impulsado por la energía pulsante del Afro Tech, mezclándolo perfectamente con la profundidad emocional y las ricas melodías del Afro House.'
      },
      bio: {
        title: 'Biografía',
        paragraph1: 'AYITE es un DJ y productor impulsado por la energía pulsante del Afro Tech, que lo mezcla perfectamente con la profundidad emocional y las ricas melodías del Afro House. Sus sets son más que música: son experiencias inmersivas arraigadas en la conexión, el movimiento y la energía cruda compartida con el público.',
        paragraph2: 'Inspirándose en las líneas de bajo pesadas del Techno, AYITE infunde su sonido Afro Tech con un borde potente pero conmovedor. Sus producciones tejen elementos de Peak Time Techno y Electronica, mezclando líneas de bajo oscuras y potentes con texturas crudas y distorsionadas para crear un sonido que es tanto personal como innovador.',
        paragraph3: 'Lo que realmente distingue a AYITE es su comprensión intuitiva de la dinámica de la pista de baile. Su capacidad para leer a una multitud y guiarla en un viaje de euforia compartida convierte cada actuación en un momento inolvidable.',
        readMore: 'Leer biografía completa'
      },
      events: {
        title: 'AYITE Live Shows',
        subtitle: 'Conectando personas y corazones a través de la música. Líneas de bajo profundas y melodías emocionales fluyen en cada ritmo - Afro Tech lidera el camino. Deja que el ritmo te mueva, deja que la energía te lleve. Esto es más que sonidos - ¡es un sentimiento! ♥️',
        viewAll: 'Ver todos los eventos'
      },
      music: {
        title: 'Escucha mi música',
        followText: 'Sígueme en',
        platform: 'SoundCloud',
        forMoreTracks: 'para más pistas'
      },
      gallery: {
        title: 'Galería',
        viewAll: 'Ver galería completa'
      },
      booking: {
        title: 'Contratación',
        text: '¿Interesado en contratar a AYITE para tu evento? Contacta directamente en Instagram.',
        button: 'Más información sobre contratación'
      }
    },
    // SoundCloud player
    soundcloud: {
      tracks: 'Pistas',
      playlists: 'Listas',
      reposts: 'Reposteos'
    },
    // Social page
    social: {
      title: 'Redes Sociales',
      allPlatforms: 'Todas las plataformas',
      followInstagram: 'Seguir en Instagram',
      followTikTok: 'Seguir en TikTok',
      subscribeYouTube: 'Suscribirse en YouTube',
      followSpotify: 'Seguir en Spotify',
      followSoundCloud: 'Seguir en SoundCloud',
      youtubePlaylist: 'Lista de reproducción destacada',
      videos: 'Videos',
      shorts: 'Shorts',
      playlists: 'Listas de reproducción'
    },
    // Video page
    video: {
      featuredVideo: 'Video Destacado',
      youtubeShorts: 'YouTube Shorts',
      youtubePlaylist: 'Lista de YouTube',
      subscribeButton: 'Suscríbete a mi canal de YouTube'
    },
    // Gallery page
    gallery: {
      title: 'Galería',
      closeButton: 'Cerrar',
      placeholder: 'Imagen de marcador',
      allPhotos: 'Todas las Fotos',
      profilePhotos: 'Fotos de Perfil',
      instagramPhotos: 'Fotos de Instagram'
    },
    // Booking page
    booking: {
      title: 'Contratación',
      contactHeading: 'Contacto para Contrataciones',
      contactText: 'Para consultas de contratación, contacta a AYITE directamente en Instagram:',
      alternativeHeading: 'Contacto Alternativo',
      alternativeText: 'También puedes contactarnos por correo electrónico:',
      pressKitHeading: 'Kit de Prensa e Información de Contratación',
      pressKitText: 'Ver kit de prensa completo, fotos, rider técnico y detalles de contratación:',
      viewPressKit: 'Ver el Kit de Prensa',
      requestInfo: 'Por favor, incluye la siguiente información en tu solicitud de contratación:',
      eventDate: 'Fecha y hora del evento',
      venueLocation: 'Nombre y ubicación del lugar',
      eventType: 'Tipo de evento y audiencia esperada',
      setDuration: 'Duración del set y requisitos específicos'
    },
    // Bio page
    bio: {
      title: 'Biografía',
      paragraph1: 'AYITE es un DJ y productor impulsado por la energía pulsante del Afro Tech, que lo mezcla perfectamente con la profundidad emocional y las ricas melodías del Afro House. Sus sets son más que música: son experiencias inmersivas arraigadas en la conexión, el movimiento y la energía cruda compartida con el público.',
      paragraph2: 'Inspirándose en las líneas de bajo pesadas del Techno, AYITE infunde su sonido Afro Tech con un borde potente pero conmovedor. En una misión para forjar su propia identidad sónica, AYITE se mantiene arraigado en el Afro Tech mientras explora sin miedo nuevos territorios sonoros.',
      paragraph3: 'Sus producciones tejen elementos de Peak Time Techno y Electronica, mezclando líneas de bajo oscuras y potentes con texturas crudas y distorsionadas para crear un sonido que es tanto personal como innovador. Es una fusión de poder y emoción, ritmo e innovación.',
      paragraph4: 'En el estudio, AYITE es igualmente visionario, empujando los límites de la música electrónica con cada lanzamiento. Sus producciones combinan diseño de sonido sofisticado con resonancia emocional, ganando apoyo creciente de fans que anhelan sustancia en la música de baile.',
      paragraph5: 'Pero lo que realmente distingue a AYITE es su comprensión intuitiva de la dinámica de la pista de baile. Su capacidad para leer a una multitud y guiarla en un viaje de euforia compartida convierte cada actuación en un momento inolvidable.',
      paragraph6: 'A medida que la música electrónica continúa evolucionando, AYITE permanece comprometido con el ethos underground y el espíritu africano, refinando constantemente su arte con autenticidad y propósito.',
      paragraph7: 'Ya sea detrás de las plataformas o en el estudio, ofrece música que resuena mucho más allá de las paredes del club, anclada en ritmo, narrativa y alma.'
    },
    // Shows page
    shows: {
      title: 'Eventos',
      subtitle: 'AYITE',
      tagline: 'Conectando personas y corazones a través de la música. Líneas de bajo profundas y melodías emocionales fluyen en cada ritmo - Afro Tech lidera el camino. Deja que el ritmo te mueva, deja que la energía te lleve. Esto es más que sonidos - ¡es un sentimiento! ♥️',
      loading: 'Cargando eventos...',
      upcomingEvents: 'Próximos Eventos',
      pastEvents: 'Eventos Pasados',
      noUpcoming: '¡No hay próximos eventos por el momento. Vuelve pronto!',
      noPast: 'No hay eventos pasados para mostrar.',
      getTickets: 'Conseguir Entradas',
      bookingInfo: 'Información de Contratación',
      bookingContact: 'Para contrataciones y consultas:',
      followXceed: 'Seguir en Xceed',
      contactBooking: 'Contactar para Contratación',
      errorMessage: 'No se pudieron obtener eventos en vivo. Usando datos de ejemplo.',
      showMorePast: 'Mostrar más eventos pasados'
    },
    // Footer
    footer: {
      copyright: '© 2025 AYITE. Todos los derechos reservados.',
      followMe: 'Sígueme en redes sociales',
      createdBy: 'Creado por',
      pressKit: 'Kit de Prensa',
      impressum: 'Aviso Legal',
      privacy: 'Política de Privacidad'
    },
    // Legal pages
    legal: {
      impressum: 'Aviso Legal',
      responsible: 'Responsable del Contenido',
      vatId: 'Número de Identificación Fiscal',
      disclaimer: 'Descargo de Responsabilidad',
      liability: {
        content: 'Responsabilidad por el Contenido',
        contentText: 'Los contenidos de nuestras páginas han sido creados con el mayor cuidado. Sin embargo, no podemos garantizar la exactitud, integridad o actualidad de los contenidos. De acuerdo con las disposiciones legales, somos responsables de nuestro propio contenido en estas páginas web. En este sentido, tenga en cuenta que no estamos obligados a supervisar la información transmitida o almacenada de terceros, ni a investigar circunstancias que apunten a una actividad ilegal.',
        links: 'Responsabilidad por Enlaces',
        linksText: 'Nuestra oferta incluye enlaces a sitios web externos de terceros. No tenemos influencia sobre los contenidos de esos sitios web, por lo tanto no podemos garantizar dichos contenidos. Los proveedores o administradores de los sitios web enlazados son siempre responsables de sus propios contenidos.',
        copyright: 'Derechos de Autor',
        copyrightText: 'Los contenidos y obras creados por los operadores del sitio en estas páginas están sujetos a la ley alemana de derechos de autor. La duplicación, procesamiento, distribución o cualquier forma de comercialización de dicho material más allá del alcance de la ley de derechos de autor requerirá el consentimiento previo por escrito de su respectivo autor o creador.'
      },
      privacy: 'Política de Privacidad',
      dataProtection: 'Protección de Datos',
      dataProtectionIntro: 'Los operadores de este sitio web se toman muy en serio la protección de sus datos personales. Tratamos sus datos personales de manera confidencial y de acuerdo con las disposiciones legales de protección de datos y esta política de privacidad.',
      dataCollection: 'Recopilación de Datos',
      dataCollectionText: 'El uso de nuestro sitio web es generalmente posible sin proporcionar datos personales. Los datos personales, como nombres, direcciones o direcciones de correo electrónico, siempre se proporcionan de forma voluntaria cuando es posible.',
      logData: 'Archivos de Registro del Servidor',
      logDataText: 'El proveedor de las páginas recopila y almacena automáticamente información en los llamados archivos de registro del servidor, que su navegador nos transmite automáticamente. Estos son: tipo de navegador y versión del navegador, sistema operativo utilizado, URL de referencia, nombre de host del ordenador que accede, hora de la solicitud del servidor. Estos datos no pueden asignarse a personas específicas. Estos datos no se fusionan con otras fuentes de datos.',
      cookies: 'Cookies',
      cookiesText: 'Nuestro sitio web utiliza cookies. Las cookies son archivos de texto que se almacenan en el navegador de Internet o por el navegador de Internet en el sistema informático del usuario. Las cookies no causan ningún daño a su ordenador y no contienen virus.',
      thirdParty: 'Servicios de Terceros',
      thirdPartyText: 'Este sitio web utiliza servicios de proveedores externos. Estos servicios pueden recopilar datos sobre su comportamiento de uso.',
      soundcloudText: 'Nuestro sitio utiliza widgets de SoundCloud. El proveedor es SoundCloud Limited, Rheinsberger Str. 76/77, 10115 Berlín, Alemania. Cuando visita nuestras páginas con el plugin de SoundCloud, se establece una conexión con los servidores de SoundCloud.',
      youtubeText: 'Nuestro sitio web utiliza plugins de YouTube, que es operado por Google. El operador de las páginas es YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066, EE.UU. Si visita una de nuestras páginas con un plugin de YouTube, se establece una conexión con los servidores de YouTube.',
      instagramText: 'Nuestro sitio web utiliza funciones del servicio Instagram. Estas funciones son ofrecidas por Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, EE.UU. Si ha iniciado sesión en su cuenta de Instagram, puede vincular el contenido de nuestras páginas a su perfil de Instagram haciendo clic en el botón de Instagram.',
      tiktokText: 'Nuestro sitio web utiliza funciones de TikTok. Estas funciones son ofrecidas por TikTok Inc., 10100 Venice Blvd, Culver City, CA 90232, EE.UU. Cuando visita nuestras páginas con contenido de TikTok, se establece una conexión con los servidores de TikTok.',
      rights: 'Sus Derechos',
      rightsText: 'Tiene derecho a recibir información sobre sus datos personales almacenados, su origen y destinatario y el propósito del procesamiento de datos en cualquier momento, de forma gratuita. También tiene derecho a la corrección, bloqueo o eliminación de estos datos. Puede contactarnos en cualquier momento en la dirección indicada en el aviso legal para más preguntas sobre el tema de los datos personales.',
      contact: 'Contacto',
      contactText: 'Si tiene alguna pregunta sobre la protección de datos, envíenos un correo electrónico o póngase en contacto con la persona responsable de la protección de datos en nuestra organización:'
    }
  }
};

export default translations;
